var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"alert",class:'custom_' + _vm.obj.type},[_c('div',{staticClass:"rower"},[_c('Icon',{attrs:{"name":_vm.obj.type}}),_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.obj.heading))])],1),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.obj.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }